/* eslint-disable */
export default {
  logging: 'A registar...',
  logCall: 'Registar chamada',
  editLog: 'Editar registo',
  select: 'Selecionar um registo correspondente',
  OnHold: 'Em espera',
  Ringing: 'A chamar',
  CallConnected: 'Chamada ligada',
  unknownUser: 'Utilizador desconhecido',
  unknownNumber: 'Anónimo',
  unavailable: 'Indisponível',
  viewDetails: 'Ver detalhes',
  addEntity: 'Criar novo',
  addLog: 'Registo',
  text: 'SMS',
  call: 'Ligar',
  addContact: 'Adicionar contacto',
  missedCall: 'Não atendida',
  inboundCall: 'Recebida',
  outboundCall: 'Efetuada',
  from: 'De',
  to: 'Para',
  hangup: 'Desligar',
  accept: 'Atender',
  toVoicemail: 'Para correio de voz',
  anonymous: 'Anónimo',
  mergeToConference: 'Unir com chamada ativa',
  hold: 'Em espera',
  unhold: 'Retomar',
  transfer: 'Transferir',
  reject: 'Rejeitar',
  switchCall: 'Passar chamada para esta aplicação',
  callSwitch: 'Mudança de chamada',
  comfirmContext:
    'Está numa chamada ativa com {displayName}. Pretende continuar a chamada neste dispositivo?',
  comfirmCancelButton: 'Cancelar',
  comfirmOKButton: 'Mudar',
  ignore: 'Ignorar',
  holdAndAnswer: 'Esp e atender',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select a matching record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"addContact"@#@ @source: @#@"Add Contact"@#@
// @key: @#@"missedCall"@#@ @source: @#@"Missed"@#@
// @key: @#@"inboundCall"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outboundCall"@#@ @source: @#@"Outbound"@#@
// @key: @#@"from"@#@ @source: @#@"From"@#@
// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"accept"@#@ @source: @#@"Answer"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge with active call"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"unhold"@#@ @source: @#@"Unhold"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
// @key: @#@"switchCall"@#@ @source: @#@"Switch Call to this app"@#@
// @key: @#@"callSwitch"@#@ @source: @#@"Call Switch"@#@
// @key: @#@"comfirmContext"@#@ @source: @#@"You're currently on an active call with {displayName}. Would you like to continue the call on this device?"@#@
// @key: @#@"comfirmCancelButton"@#@ @source: @#@"Cancel"@#@
// @key: @#@"comfirmOKButton"@#@ @source: @#@"Switch"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"holdAndAnswer"@#@ @source: @#@"Hold & Answer"@#@
